import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AuthService, BaseSiteService, OccEndpointsService } from '@spartacus/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from 'src/app/spartacus/features/asm/asm-constant';
import { StorageService } from '../storage/storage.service';

export interface NewsPayload {
  category?: string;
  currentPage?: number;
  fields?: string;
  pageSize?: number;
}

export interface NewsCategoryPayload {
  newsPageId?: string;
}

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  occUrl = this.meta.getTag('name=occ-backend-base-url');
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  public categoryChange = new Subject<any>();
  categoryChange$: Observable<any>;
  asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);

  constructor(
    private meta: Meta,
    protected http: HttpClient,
    protected auth: AuthService,
    protected baseService: BaseSiteService,
    private occEndpointsService: OccEndpointsService,
    private storageService: StorageService
  ) {
    this.categoryChange$ = this.categoryChange.asObservable();
  }
  getNews(payload: NewsPayload): Observable<any> {
    const params = new HttpParams()
      .set('currentPage', payload.currentPage as any)
      .set('fields', payload.fields)
      .set('pageSize', payload.pageSize as any)
      .set('type', payload.category);

    return this.http
      .get(this.occEndpointsService.buildUrl(`/news/${payload.category}`), { params, headers: this.headers })
      .pipe(
        map((data) => data),
        catchError(this.errorHandlr)
      );
  }

  getNewsCategory(payload: NewsCategoryPayload): Observable<any> {
    return this.http
      .get(this.occEndpointsService.buildUrl(`/news/getCategory/${payload.newsPageId}`), {
        headers: this.headers,
      })
      .pipe(
        map((data) => data),
        catchError(this.errorHandlr)
      );
  }

  errorHandlr(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
